module.exports = __webpack_public_path__ + "img/logo.5eb3d121.svg";